import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { AccountSwitcher } from "@src/containers/redesign/AppLayout/Header/AccountSwitcher";
import { BunnyLogo, ClipboardLogo } from "@src/appV2/redesign/components/Logos";
import { type SessionType } from "@src/modules/interface";
import { pseudo } from "@src/modules/session";
import { FacilityTypes } from "@src/appV2/redesign/utils/facility";
import { getLocation, routes } from "@src/appV2/redesign/utils/routes";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";

import { Button } from "@src/appV2/redesign/components/Button";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { useWorkplaceMenuPriviligesProviderContext } from "../priviligesProviders/WorkplaceMenuPriviligesProvider";

export function AppLayoutHeader() {
  const workplaceMenuPriviliges = useWorkplaceMenuPriviligesProviderContext();

  const dispatch = useDispatch();
  const history = useHistory();
  const session = useSelector((state: SessionType) => state.session ?? {});
  const { profile, adminUserId, admin, adminProfile, type, user } = session;

  // Determine user type
  const isAdminUser = admin;
  const isFacilityUser = type === "FACILITY";

  // Create a dispatched version of the pseudo action
  const handlePseudo = (data: { userId: string }, isFirebaseSession?: boolean) => {
    return dispatch(pseudo(data, isFirebaseSession));
  };

  const JUST_CLIPBOARD_LOGO_URL = `${process.env.REACT_APP_BASE_PATH ?? "/"}justClipboard.png`;
  const BUNNY_EDUCATION_LOGO_URL = `${process.env.REACT_APP_BASE_PATH ?? "/"}bunnyEducation.png`;

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      spacing={5}
      paddingX={5}
      paddingY={2}
    >
      <Link to={routes.enter}>
        <Stack direction="row" alignItems="center" gap={3}>
          <BunnyLogo
            height={50}
            width={50}
            url={
              profile?.type === FacilityTypes.SCHOOL ||
              profile?.type === FacilityTypes.CHILD_CARE_CENTER
                ? BUNNY_EDUCATION_LOGO_URL
                : undefined
            }
          />
          <ClipboardLogo
            height={30}
            width={100}
            url={
              profile?.type === FacilityTypes.SCHOOL ||
              profile?.type === FacilityTypes.CHILD_CARE_CENTER ||
              !isDefined(profile?.type)
                ? JUST_CLIPBOARD_LOGO_URL
                : undefined
            }
          />
        </Stack>
      </Link>

      <Stack direction="row" alignItems="center" gap={3} height="100%">
        {workplaceMenuPriviliges.managementSection?.settings && (
          <Button
            variant="linkInverted"
            endIconType="question-circle"
            onClick={() => {
              history.push(getLocation("helpCenter"));
            }}
          >
            Help
          </Button>
        )}

        {workplaceMenuPriviliges.managementSection?.settings && (
          <IconButton
            iconType="cogwheel"
            variant="linkInverted"
            onClick={() => {
              history.push(getLocation("facilitySettings"));
            }}
          />
        )}

        <IconButton iconType="bell-solid" variant="linkInverted" />
        <AccountSwitcher
          adminUserId={adminUserId ?? ""}
          pseudo={handlePseudo}
          isAdminUser={isAdminUser}
          isFacilityUser={isFacilityUser}
          facilityName={profile?.name}
          userName={user?.name}
          adminName={adminProfile?.name}
        />
      </Stack>
    </Stack>
  );
}
